import {useEffect, useState} from 'react';
import {findAreaList, getAreaList} from '../../api/commonApi';
import Select from "react-select";

interface AreaSelectProps {
    selectedMainArea: string;
    selectedSubArea: string;
    onMainAreaChange: (mainAreaCode: string) => void;
    onSubAreaChange: (subAreaCode: string) => void;
    onMainAreaLabelChange?: (label: string) => void;
    onSubAreaLabelChange?: (label: string) => void;
    required?: boolean;
    disabled?: boolean;
}

const AreaSelectComponent = ({
                                 selectedMainArea,
                                 selectedSubArea,
                                 onMainAreaChange,
                                 onSubAreaChange,
                                 onMainAreaLabelChange,
                                 onSubAreaLabelChange,
                                 required = false,
                                 disabled = false
                             }: AreaSelectProps) => {
    const [mainAreaList, setMainAreaList] = useState<any[]>([]);
    const [subAreaList, setSubAreaList] = useState<any[]>([]);


    const mainAreaOptions = mainAreaList.map((area: any) => ({
        value: area.coCode,
        label: area.displayName || area.coName,
    }));

    const subAreaOptions = subAreaList.map((area: any) => ({
        value: area.coCode,
        label: area.displayName || area.coName,
    }));

    // 광역시/도 목록 조회
    useEffect(() => {
        const fetchMainAreaList = async () => {
            try {
                const res = await getAreaList();
                if (res.data?.data && Array.isArray(res.data.data)) {
                    const mainAreas = res.data.data.filter((area: any) => !area.upCoCode);
                    setMainAreaList(mainAreas);
                }
            } catch (error) {
                console.error('Failed to fetch main area list:', error);
            }
        };
        fetchMainAreaList();
    }, []);

    // 기존 값이 있을 때 시/군/구 목록 로드
    useEffect(() => {
        if (selectedMainArea) {
            const fetchSubAreaList = async () => {
                try {
                    const res = await findAreaList(selectedMainArea);
                    if (res.data?.data && Array.isArray(res.data.data)) {
                        setSubAreaList(res.data.data);
                    }
                } catch (error) {
                    console.error('Failed to fetch sub area list:', error);
                    setSubAreaList([]);
                }
            };
            fetchSubAreaList();
        }
    }, [selectedMainArea]);

    // 광역시/도 선택 핸들러
    const handleMainAreaChange = async (opt: { value: string; label: string } | null) => {
        const mainAreaCode = opt?.value ?? "";
        onMainAreaChange(mainAreaCode);
        onMainAreaLabelChange?.(opt?.label ?? "");
        onSubAreaChange(""); // 시/군/구 초기화
        onSubAreaLabelChange?.("");

        if (mainAreaCode) {
            try {
                const res = await findAreaList(mainAreaCode);

                if (res.data?.data && Array.isArray(res.data.data)) {
                    setSubAreaList(res.data.data);
                }
            } catch (error) {
                console.error('Failed to fetch sub area list:', error);
                setSubAreaList([]);
            }
        } else {
            setSubAreaList([]);
        }
    };

    // 시/군/구 선택 핸들러
    const handleSubAreaChange = (opt: { value: string; label: string } | null) => {
        onSubAreaChange(opt?.value ?? "");
        onSubAreaLabelChange?.(opt?.label ?? "");
    };

    return (<>
            <div className="col2">
                <div className="custom-select-react">
                    <Select
                        placeholder="광역시/도"
                        value={mainAreaOptions.find(o => o.value === selectedMainArea) ?? null}
                        onChange={handleMainAreaChange}
                        options={mainAreaOptions}
                        isDisabled={disabled}
                        isSearchable={false}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            singleValue: (base) => ({ ...base, whiteSpace: 'nowrap' }),
                            placeholder: (base) => ({ ...base, whiteSpace: 'nowrap' }),
                        }}
                    />
                </div>
                <div className="custom-select-react">
                    <Select
                        placeholder="시/군/구"
                        value={subAreaOptions.find(o => o.value === selectedSubArea) ?? null}
                        onChange={handleSubAreaChange}
                        options={subAreaOptions}
                        isDisabled={disabled || !selectedMainArea || subAreaList.length === 0}
                        isSearchable={false}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            singleValue: (base) => ({ ...base, whiteSpace: 'nowrap' }),
                            placeholder: (base) => ({ ...base, whiteSpace: 'nowrap' }),
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default AreaSelectComponent;